import { Injectable } from '@angular/core';
import { ApiService } from './helpers/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiResourcesV1 } from './helpers/api-resources';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  constructor(private http: ApiService) {}

  uploadMedia(data, reportProgress = false): Observable<any> {
    const options: any = {};
    if (reportProgress) {
      options.reportProgress = true;
      options.observe = 'events';
    }
    return this.http.post(apiResourcesV1.media, data, true, options).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }
}
